export default __webpack_public_path__ + "static/media/tools.fa07c779.svg";